import { camelize } from 'humps';

export const VERIFIED_BY_PARTNER = 'partner';
export const NOT_VERIFIED = 'none';

const formattedInputValue = (key, input, candidateNameStr) => {
  if (!input) return '-';
  switch (key) {
    case 'certificationIssuedTo':
      return input.businessName || candidateNameStr;
    default:
      return input[key] || '-';
  }
};

export const candidateName = candidate =>
  ['firstName', 'middleName', 'lastName']
    .map(name => candidate[name])
    .filter(Boolean)
    .join(' ');

export const formattedSubResultInputValue = (subResult, input) => {
  if (!input) return '-';
  return input[subResult.name] || input[camelize(subResult.name)] || '-';
};

const isPartnerResult = r => r.verifiedBy === VERIFIED_BY_PARTNER;

export const isPartnerVerified = ({ result = {}, results = [] }) =>
  isPartnerResult(result) ||
  (Array.isArray(results) && results.some(isPartnerResult));

export const getEffectivePartnerResults = certification => {
  const { result = {}, results } = certification;
  const allResults =
    Array.isArray(results) && results.length > 0 ? results : [result];
  return allResults.filter(isPartnerResult);
};

const hasConsiderSubCheck = result =>
  Array.isArray(result.subChecks) &&
  result.subChecks.some(
    ({ status }) =>
      typeof status === 'string' && status.toLowerCase() === 'consider',
  );

export const isCertificationNotFound = partnerResults =>
  Array.isArray(partnerResults) && partnerResults.some(hasConsiderSubCheck);

export const resultKey = (r, idx) =>
  `${r.certificationIssuedTo}-${r.certificationIssuerRegion}-${idx}`;

export const getUniqueSubResults = partnerResults =>
  Array.from(
    new Map(
      partnerResults.flatMap(r => r.subResults || []).map(sr => [sr.name, sr]),
    ).values(),
  );

export default formattedInputValue;
